import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import { usePermissions } from "../../helper/PermissionContext";

// Each top-level menu group = one permission slug from the API.
const MENU = {
  dashboard: "dashboard",
  userManagement: "user-management",
  dynamicPage: "dynamic-page",
  blogManagement: "blog-management",
  seoManagement: "seo-management",
  newsManagement: "news-management",
  branchManagement: "branch-management",
  faqManagement: "faq-management",
  sitemap: "sitemap",
  globalSeo: "global-seo",
  llmsManagement: "llms-management",
  robotsManagement: "robots-management",
  emailManagement: "email-management",
  mandatoryDisclosure: "mandatory-disclosure",
  contactUs: "contact-us",
  scheduleVisit: "schedule-a-visit",
  applyNow: "apply-now",
  career: "career",
};

export default function SideBar({ isOpen, toggleSidebar }) {
  const [isBlogManagementOpen, setIsBlogManagementOpen] = useState(false);
  const [isUserManagementOpen, setIsUserManagementOpen] = useState(false);

  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  const toggleBlogManagement = () => setIsBlogManagementOpen((prev) => !prev);
  const toggleUserManagement = () => setIsUserManagementOpen((prev) => !prev);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login", { replace: true });
  };

  return (
    <>
      <div className={`admin-logo-wrap ${isOpen ? "close" : "open"}`}>
        <img src="/assets/logo.webp" alt="logo" className="img-responsive" />
        <button className="toggle-button" onClick={toggleSidebar}>
          ☰
        </button>
      </div>
      <div className={`admin-sidebar ${isOpen ? "close" : "open"}`}>
        <div className="scroller-sidebar">
          <ul style={isOpen
            ? { transition: "all 0.3s ease-in", opacity: "0", visibility: "hidden" }
            : { transition: "all 0.3s ease-in", opacity: "1", visibility: "visible" }}>

            {hasPermission(MENU.dashboard) && (
              <li>
                <Link to="/"><span><img src="/assets/dashboard.webp" alt="icon" className="img-responsive" />Dashboard</span></Link>
              </li>
            )}

           {hasPermission(MENU.userManagement) && (
              <li className={`innertab ${isUserManagementOpen ? "openlist" : ""}`} onClick={toggleUserManagement}>
                <div><span><img src="/assets/dashboard.webp" alt="icon" className="img-responsive" /> User Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isUserManagementOpen ? "open" : "close"}`}>
                  <li><Link to="users">Users</Link></li>
                  <li><Link to="roles">Roles</Link></li>
                  <li><Link to="permissions">Permissions</Link></li>
                </ul>
              </li>
           )}
            

            {hasPermission(MENU.dynamicPage) && (
              <li>
                <Link to="/dynamic-page"><span><img src="/assets/dynamic-page.webp" alt="icon" className="img-responsive" />Dynamic Page</span></Link>
              </li>
            )}

            {hasPermission(MENU.blogManagement) && (
              <li className={`innertab ${isBlogManagementOpen ? "openlist" : ""}`} onClick={toggleBlogManagement}>
                <div><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Blog Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isBlogManagementOpen ? "open" : "close"}`}>
                  <li><Link to="blog">Blog</Link></li>
                  <li><Link to="category">Category</Link></li>
                  <li><Link to="author">Author</Link></li>
                  <li><Link to="tag">Tag</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.seoManagement) && (
              <li>
                <Link to="seo"><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" /> SEO Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.newsManagement) && (
              <li>
                <Link to="news"><span><img src="/assets/news-icon.webp" alt="icon" className="img-responsive" /> News Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.branchManagement) && (
              <li>
                <Link to="branch"><span><img src="/assets/branch-icon.webp" alt="icon" className="img-responsive" /> Branch Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.faqManagement) && (
            <li>
              <Link to="faq"><span><img src="/assets/faq-icon.webp" alt="icon" className="img-responsive" /> FAQ Management</span></Link>
            </li>
            )}

            {hasPermission(MENU.sitemap) && (
            <li>
              <Link to="sitemap"><span><img src="/assets/sitemap-management.webp" alt="icon" className="img-responsive" /> Sitemap Management</span></Link>
            </li>
            )}

            {hasPermission(MENU.globalSeo) && (
            <li>
              <Link to="global-seo"><span><img src="/assets/schema-management.webp" alt="icon" className="img-responsive" /> Global SEO</span></Link>
            </li>
            )}

            {hasPermission(MENU.llmsManagement) && (
            <li>
              <Link to="llms"><span><img src="/assets/sitemap-management.webp" alt="icon" className="img-responsive" /> LLMS Management</span></Link>
            </li>
            )}

            {hasPermission(MENU.robotsManagement) && (
            <li>
              <Link to="robots"><span><img src="/assets/sitemap-management.webp" alt="icon" className="img-responsive" /> Robots.txt Management</span></Link>
            </li>
            )}

            {hasPermission(MENU.emailManagement) && (
            <li>
              <Link to="email-management"><span><img src="/assets/schema-management.webp" alt="icon" className="img-responsive" /> Email Management</span></Link>
            </li>
            )}

            {hasPermission(MENU.mandatoryDisclosure) && (
              <li>
                <Link to="/disclosure"><span><img src="/assets/disclosure-icon.webp" alt="icon" className="img-responsive" />Mandatory Disclosure</span></Link>
              </li>
            )}

            {hasPermission(MENU.contactUs) && (
              <li>
                <Link to={"contact"}><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" /> Contact Us</span></Link>
              </li>
            )}

            {hasPermission(MENU.scheduleVisit) && (
              <li>
                <Link to={"schedule-visit"}><span><img src="/assets/schedule-icon.webp" alt="icon" className="img-responsive" /> Schedule A Visit</span></Link>
              </li>
            )}

            {hasPermission(MENU.applyNow) && (
              <li>
                <Link to={"apply-now"}><span><img src="/assets/apply-icon.webp" alt="icon" className="img-responsive" /> Apply Now</span></Link>
              </li>
            )}

            {hasPermission(MENU.career) && (
              <li>
                <Link to={"career"}><span><img src="/assets/career-icon.webp" alt="icon" className="img-responsive" /> Career</span></Link>
              </li>
            )}
          </ul>
        </div>

        <button onClick={handleLogout} className="default-btn logout-button">Logout<span></span></button>
      </div>
    </>
  );
}
